import { Theming } from '~schemas/settings';

export function generateFontUrls(theme: Theming): string[] {
  const urls: string[] = [];

  Object.values(theme.fonts).forEach((v) => {
    if (v.url && v.url.startsWith('https://')) {
      urls.push(v.url);
      return;
    }

    // Google fonts
    const fontWeights = ['400', '500', '600', '700', '800'];
    const fontUrl = `https://fonts.googleapis.com/css?family=${v.family}:${fontWeights.join(',')}`;
    urls.push(fontUrl);
  });

  return urls;
}

export function applyFont(url: string) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);
}

function applyMapping(mapping: Record<string, string>, values: Record<string, any>) {
  Object.entries(mapping).forEach(([key, cssVar]) => {
    if (values[key]) {
      // If the value is an object (as with fonts), use its `family` property
      const value = typeof values[key] === 'object' && values[key] !== null && 'family' in values[key] ? values[key].family : values[key];
      document.documentElement.style.setProperty(cssVar, value);
    }
  });
}

export function applyTheming(theming: Theming) {
  const mappings: Record<keyof Theming, Record<string, string>> = {
    fonts: {
      heading: '--font-heading',
      body: '--font-body',
    },
    surface: {
      primary: '--color-surface-primary',
      primary_support: '--color-surface-primary-support',
      neutral: '--color-surface-neutral',
      focus: '--color-surface-focus',
      positive: '--color-surface-positive',
      positive_support: '--color-surface-positive-support',
      warning: '--color-surface-warning',
      warning_support: '--color-surface-warning-support',
      error: '--color-surface-error',
      error_support: '--color-surface-error-support',
      shadow: '--color-surface-shadow',
      hover: '--color-surface-hover',
      video_overlay_button: '--color-surface-video-overlay-button',
      modal_overlay: '--color-surface-modal-overlay',
    },
    border: {
      primary: '--color-border-primary',
      disabled: '--color-border-disabled',
    },
    text: {
      heading: '--color-text-heading',
      body: '--color-text-body',
      secondary: '--color-text-secondary',
      focus: '--color-text-focus',
      disabled: '--color-text-disabled',
      overlay_disabled: '--color-text-overlay-disabled',
    },
  };

  // Fix: Explicitly assert that section is a keyof Theming
  (Object.keys(mappings) as (keyof Theming)[]).forEach((section) => {
    applyMapping(mappings[section], theming[section] || {});
  });

  // Apply fonts
  generateFontUrls(theming).forEach((url) => {
    applyFont(url);
  });
}
